<div class="documents-holder" *ngIf="invoices && invoices.length">
    <ul>
        <li *ngFor="let invoice of invoices">
            <a href="{{ invoice.url}}" target="_blank">
                <serviceos-ng-system-icon class="sos-icon" [icon]="'doc'"></serviceos-ng-system-icon>
                <span>{{ invoice.title }}</span>
            </a>
        </li>
    </ul>
</div>